import { Reveal } from "./motion-primitives";

const PILLARS = [
  {
    label: "AI for intelligence",
    body: "Technology helps with research, organization and drafting, giving us more time to focus on the details that matter to you.",
  },
  {
    label: "Human for taste",
    body: "We review the options, work with destination partners and discuss the trade-offs with you. Final recommendations remain a human decision.",
  },
];

// Concise brand principle — no diagrams, no robot iconography.
export const AiHuman = () => {
  return (
    <section
      id="ai-human"
      data-testid="ai-human-section"
      className="mx-auto max-w-[1400px] px-6 py-16 sm:px-10 lg:px-16 lg:py-20"
    >
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">The Holideviser method</span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-6 font-serif text-5xl font-light leading-[1.02] tracking-tight text-cream sm:text-6xl">
              Better <span className="italic text-teal">with both.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.14}>
            <p className="mt-6 max-w-sm font-sans text-base leading-relaxed text-sand">
              AI supports the planning work. Human judgment shapes the recommendations and the trip.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:col-span-7 lg:gap-16">
          {PILLARS.map((p, i) => (
            <Reveal key={p.label} delay={0.1 + i * 0.1}>
              <div className="flex flex-col gap-4 border-t border-charcoal pt-6">
                <span className="font-sans text-xs uppercase tracking-[0.24em] text-cream">{p.label}</span>
                <p className="font-serif text-xl font-light leading-snug text-cream/85 sm:text-2xl">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
